module.exports = __webpack_public_path__ + "img/zdwx_logo@2x.572d2eee.png";